<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="10">
          <v-card v-if="!loadingProducts">
            <v-card-title class="headline" primary-title>
              <div class="mb-8">
                Add missing wholesale prices
                <v-icon color="accent">mdi-arrow-down-circle</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="products"
                    :footer-props="{
                      'items-per-page-options': [50, 100, 150, 200],
                    }"
                  >
                    <template v-slot:[`item.Photos`]="{ item }">
                      <tr>
                        <td style="width: 100px">
                          <expandable-image
                            max-width="100px"
                            contain
                            :src="item.Photos[0]"
                          ></expandable-image>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:[`item.WholesalePrice`]="{ item }">
                      <td>
                        <v-text-field
                          outlined
                          dense
                          :rules="[number]"
                          type="number"
                          v-model="item.WholesalePrice"
                          hide-details="auto"
                        ></v-text-field>
                      </td>
                    </template>
  
                    <!-- <template v-slot:item.WholesalePrice="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.WholesalePrice"
                        @save="save"
                        @cancel="cancel"
                        @open="open"
                        @close="close"
                      >
                        {{ props.item.WholesalePrice }}
                        <template v-slot:input>
                          <v-text-field
                            v-model="props.item.WholesalePrice"
                            :rules="[number]"
                            label="Wholesale price"
                            single-line
                            type="number"
                            min="0"
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                      <v-divider></v-divider>
                    </template> -->
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn color="error" outlined @click="goBack">
                <v-icon left color="error">mdi-arrow-left-bold</v-icon>
                Back
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                outlined
                @click="pushPrices"
                :disabled="products.length == 0"
                >Continue
                <v-icon right color="success">mdi-arrow-right-bold</v-icon></v-btn
              >
            </v-card-actions>
          </v-card>
          <v-card flat v-if="loadingProducts">
            <v-card-text v-if="!failed">
              <v-row justify="center" class="mt-16">
                <v-col cols="4">
                  <v-progress-circular
                    :size="70"
                    color="accent"
                    indeterminate
                  ></v-progress-circular>
                </v-col>
              </v-row>
              <v-row justify="center">
                <h3 class="basic--text text-center">
                  Adding wholesale prices...
                </h3>
              </v-row>
            </v-card-text>
            <v-card-text v-else>
              <v-row justify="center" class="mt-16">
                <v-col cols="4">
                  <h2>{{ errorMsg }}</h2>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-16">
                <v-col cols="4">
                  <v-img src="@/assets/no_data.svg"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "WholesalePriceEdit",
    components: {},
    props: {
      products: Array,
    },
    data: () => ({
      headers: [
        { text: "", value: "Photos", class: "basic--text", divider: true },
        { text: "SKU", value: "SKU", class: "basic--text", divider: true },
        {
          text: "Category",
          value: "Category",
          class: "basic--text",
          divider: true,
        },
        {
          text: "Style name",
          value: "StyleName",
          class: "basic--text",
          divider: true,
        },
        {
          text: "Style code",
          value: "StyleCode",
          class: "basic--text",
          divider: true,
        },
        { text: "RRP (€)", value: "RRP", class: "basic--text", divider: true },
        {
          text: "Wholesale price (€)",
          value: "WholesalePrice",
          class: "basic--text",
          divider: true,
          align: "center",
          // cellClass: "footer",
        },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      min0: (v) => v > 0 || "Input too small!",
      loadingProducts: false,
      failed: false,
      errorMsg: "",
      number: (v) => v > 0 || "Please enter a positive number",
    }),
    mounted() {
      //sort products so that products which do not have WholesalePrice will be on top of the ist
      this.products.sort((a, b) => {
        if (a.WholesalePrice == undefined && b.WholesalePrice == undefined)
          return 0;
        if (a.WholesalePrice == undefined) return -1;
        if (b.WholesalePrice == undefined) return 1;
        if (a.WholesalePrice > b.WholesalePrice) return -1;
        if (a.WholesalePrice < b.WholesalePrice) return 1;
        if (a.WholesalePrice == b.WholesalePrice) return 0;
      });
    },
    methods: {
      async pushPrices() {
        this.loadingProducts = true;
        let productsArray = [];
        let formData = new FormData();
        this.products = await this.wholesalePriceToNumber(this.products);
        for (let indx in this.products) {
          formData.append("products", JSON.stringify(this.products[indx]));
        }
        try {
          const response = await this.$store.dispatch(
            "putWholesalePrices",
            formData
          );
          if (response.status == 200) {
            productsArray = response.data;
          }
          this.$emit("getSizes", productsArray);
        } catch (error) {
          this.errorMsg = error.response.data
            ? error.response.data
            : "Something went wrong...";
          this.failed = true;
        }
      },
      async wholesalePriceToNumber(products) {
        return products.map((el) => {
          if (el.WholesalePrice && el.WholesalePrice != "") {
            el["WholesalePrice"] = parseFloat(el.WholesalePrice);
          }
          return el;
        });
      },
      goBack() {
        this.$emit("backToFilter");
      },
    },
  };
  </script>
  